export default {
  socAuth: (state) => state.socialAuth
}
